import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

// Uppercase-tracked eyebrow label used above card sections and form
// subsections. Replaces the ~6-times-copied
// `text-sm font-medium uppercase tracking-wide text-slate-500` recipe with
// a single component routed through the muted-foreground token so a brand
// swap propagates. Semantics: this is an h3/eyebrow, not an interactive
// element — render inside CardHeader or above a form group.
export function SectionLabel({ className, ...rest }: ComponentProps<'div'>) {
  return (
    <div
      className={cn(
        'text-xs font-semibold uppercase tracking-wide text-muted-foreground',
        className,
      )}
      {...rest}
    />
  );
}
